import React from 'react';

import { ScreenLink } from '@gogame/screens';

import {
  conceptDetailsLink,
  creativeDetailsLink,
} from 'scenes/Gallery/GalleryPage/navigation';

export const GalleryLink = ({
  relatedActionId,
  type,
  onClick,
  children,
  ...props
}) => {
  switch (type) {
    case 'GalleryNewConcept': {
      return (
        <ScreenLink
          link={conceptDetailsLink}
          params={{
            id: relatedActionId,
          }}
          target={'_blank'}
          fast={true}
          onClick={onClick}
          {...props}
        >
          {children}
        </ScreenLink>
      );
    }
    case 'GalleryConceptCommentMention': {
      return (
        <ScreenLink
          target={'_blank'}
          onClick={onClick}
          link={conceptDetailsLink}
          params={{
            id: relatedActionId,
          }}
          {...props}
        >
          {children}
        </ScreenLink>
      );
    }
    case 'GalleryCreativeCommentMention': {
      return (
        <ScreenLink
          target={'_blank'}
          onClick={onClick}
          link={creativeDetailsLink}
          params={{
            id: relatedActionId,
          }}
          {...props}
        >
          {children}
        </ScreenLink>
      );
    }
    case 'GalleryConceptExpiration':
    case 'GalleryConceptArchiving': {
      return (
        <ScreenLink
          target={'_blank'}
          onClick={onClick}
          link={conceptDetailsLink}
          params={{
            id: relatedActionId,
          }}
          {...props}
        >
          {children}
        </ScreenLink>
      );
    }

    default: {
      return null;
    }
  }
};
